module.exports = __webpack_public_path__ + "img/40_69_011_790.7a2a49cc.jpg";